enum Civilite {
  MONSIEUR = "Monsieur",
  MADAME = "Madame"
}

export default Civilite